import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import arrowRight from "./assets/arrow-right.svg";
import "./input.scss";

export const Input = ({
  placeholder,
  disabled,
  select,
  sendCode,
  isTop,
  selectAreaHandler,
  isTopText,
  styleClass,
  titleClass,
  value,
  type,
  length,
  checkCode,
  getValue,
  valueText,
  setTitlePupop,
  titleText,
  isSend,
  setIsSend,
}) => {
  const [isFocus, setIsFocus] = useState(value ? true : false);

  const focusHandler = () => {
    setIsFocus(true);
    selectAreaHandler && selectAreaHandler(true);
  };

  const { t } = useTranslation();

  const [inputValue, setInputValue] = useState("");

  const blurHanlder = () => {
    !inputValue && !value && setIsFocus(false);
  };

  const setValue = (v) => {
    getValue && getValue(v);
    setInputValue(v);
  }

  const [codeText, setCodeText] = useState(
    "发送验证码"
  );

  const changeInput = (e) => {
    const v = e.target.value;
    value || v ? setIsFocus(true) : setIsFocus(false);

    length
      ? v.length < length
        ? setValue(v)
        : setValue(v.slice(0, length))
      : setValue(v);
  };

  const [timer, setTimer] = useState(59);
  // const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    let countdown

    if (isSend) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 0) {
            // setIsCounting(false);
            setIsSend && setIsSend(false);
            setCodeText(t("重新发送"));
          } else {
            setCodeText(prevTimer + "s " + t("重新发送"));
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(countdown);
    };
  }, [isSend]);

  const startCountdown = () => {
    if (!valueText) {
      setTitlePupop && titleText && setTitlePupop(titleText);
      return;
    }
    checkCode && checkCode();
    setTimer(60);
    // setIsCounting(true);
    setIsSend && setIsSend(false);
  };

  return (
    <div className="input-container">
      {select && (
        <>
          <div
            className={`input areaText ${isFocus || isTop ? "action-input" : ""} `}
            onClick={focusHandler}
          >
            {value}
          </div>
          <img src={arrowRight} className="arrow-right" />
          {isFocus && (
            <legend className="right-title" style={titleClass}>
              {isTopText}
            </legend>
          )}
        </>
      )}
      {!select && (
        <>
          <input
            placeholder={placeholder}
            className={`input ${isFocus || isTop ? "action-input" : ""} `}
            disabled={disabled}
            onFocus={focusHandler}
            onBlur={blurHanlder}
            onChange={(e) => changeInput(e)}
            value={value ? value : inputValue}
            style={styleClass}
            type={type}
            maxLength={length}
          />

          {isFocus && (
            <legend className="right-title" style={titleClass}>
              {isTopText}
            </legend>
          )}

          {sendCode && (
            <button
              className={
                !isSend
                  ? "arrow-text arrow-text-new"
                  : "arrow-text arrow-text-old"
              }
              disabled={isSend}
              onClick={startCountdown}
            >
              {t(codeText)}
            </button>
          )}
        </>
      )}
    </div>
  );
};
